import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<void, 'checked'>()(
  (theme, _params, classes) => ({
    content: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignSelf: 'stretch',
    },
    cardSubTitle: {
      fontSize: theme.spacing(1.75),
      fontWeight: 400,
      lineHeight: theme.spacing(2.5),
      letterSpacing: '0.25px',
      color: theme.palette.labraText.description,
    },
    form: {
      minWidth: 0,
      width: '100%',
      '& .MuiRadioGroup-root': {
        gap: theme.spacing(3),
        flexWrap: 'wrap',
        marginTop: theme.spacing(2),
      },
    },
    migrationCheckbox: {
      marginTop: theme.spacing(2),
    },
    migrationStatus: {
      marginTop: theme.spacing(2),
      fontSize: theme.spacing(1.75),
      fontWeight: 500,
      lineHeight: theme.spacing(2.5),
      letterSpacing: '0.1px',
      color: theme.palette.labraText.primary,
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-start',
      marginTop: theme.spacing(3),
    },
    radio: {
      padding: theme.spacing(0.75),
      [`&.${classes.checked}`]: {
        color: theme.palette.listingStatus.main,
      },
    },
    checked: {},
    radioLabel: {
      alignItems: 'center',
      marginRight: 0,
      marginLeft: 0,
      marginBottom: 0,
      '& .MuiRadio-root': {
        padding: theme.spacing(0.5),
      },
      '& .MuiFormControlLabel-label': {
        fontSize: theme.spacing(2),
        fontWeight: 400,
        lineHeight: theme.spacing(3),
        letterSpacing: '0.15px',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
      },
      '&.Mui-disabled': {
        opacity: 1,
        '& .MuiFormControlLabel-label': {
          color: theme.palette.labraText.primary,
          '-webkit-text-fill-color': theme.palette.labraText.primary,
        },
      },
    },
  })
)
